import React, { useEffect, useState, useRef, useContext } from 'react';
import EmpresaContext from "../../../../contexts/Empresa";
import { useHistory } from 'react-router-dom'
import { AxiosResponse } from 'axios';
import { bindErrors } from "../../../../utils";
import api from "../../../../services/api";
import { SITUACOES_SCRIPT } from '../constants';
//@ts-ignore
import NotificationAlert from "react-notification-alert";
//@ts-ignore
import ReactBSAlert from "react-bootstrap-sweetalert";
import {
    Card,
    CardBody,
    CardHeader,
    Row,
    Col,
    Button,
    FormGroup,
    Input,
    Spinner,
    CardFooter,
} from "reactstrap";

interface IForm {
    scriptId?: number
}

interface IError {
    titulo: string,
    conteudo: string,
    descricao: string,
    tags: string
}

const Form: React.FC<IForm> = ({ scriptId }) => {

    const { empresaSelecionada } = useContext(EmpresaContext)
    const history = useHistory()

    const [script, setScript] = useState<any>({})
    const [titulo, setTitulo] = useState('')
    const [descricao, setDescricao] = useState('')
    const [conteudo, setConteudo] = useState('')
    const [tags, setTags] = useState('')
    const [situacao, setSituacao] = useState('')
    const [perfilNegocioId, setPerfilNegocioId] = useState<string>('')
    const [perfisNegocio, setPerfisNegocio] = useState<any[]>([])
    const [alert, setAlert] = useState<any>(null)
    const [saving, setSaving] = useState(false)
    const [erros, setErros] = useState<IError>({} as IError)

    const notificationAlert = useRef<NotificationAlert>(null)

    useEffect(() => {
        loadPerfisNegocio()
    }, [])

    useEffect(() => {
        if (scriptId) loadScript()
    }, [scriptId])

    useEffect(() => {
        if (script.id) {
            fillScript(script)
        }
    }, [script])

    async function loadPerfisNegocio() {
        try {
            const response = await api.get('/common/perfis_negocio')
            setPerfisNegocio(response.data || [])
        } catch (error) {
            console.error(error)
        }
    }

    async function loadScript() {
        try {
            const response = await api.get(`/common/empresas/${empresaSelecionada?.id}/scripts-venda/${scriptId}`)
            setScript(await response.data)
        } catch (error) {
            console.error(error)
            notify('danger', 'Não foi possível carregar script de venda')
        }
    }

    function fillScript(data: any) {
        setTitulo(data.titulo || '')
        setDescricao(data.descricao || '')
        setConteudo(data.conteudo || '')
        setTags(data.tags || '')
        setSituacao(data.situacao || '')
        setPerfilNegocioId(data.perfil_negocio_id ? String(data.perfil_negocio_id) : '')
    }

    const notify = (type: string, msg: string) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text" style={{ zIndex: 100 }}>
                    <span data-notify="message">
                        {msg}
                    </span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 3
        };
        //@ts-ignore
        if (notificationAlert.current) {
            notificationAlert.current.notificationAlert(options);
        }
    };

    async function handleSave() {
        setSaving(true)
        if (script.id) {
            await update()
        } else {
            await insert()
        }
        setSaving(false)
    }

    async function insert() {
        try {
            await api.post(`common/empresas/${empresaSelecionada?.id}/scripts-venda`, bind())
            successAlert('Script de Venda salvo')
        } catch (error: any) {
            setSaving(false)
            console.log(error)
            notify('danger', 'Não foi possível salvar script de venda')
            if (error.response) updateErros(error.response)
        }
    }

    async function update() {
        try {
            await api.put(`common/empresas/${empresaSelecionada?.id}/scripts-venda/${scriptId}`, bind())
            successAlert('Script de Venda salvo')
        } catch (error: any) {
            setSaving(false)
            console.log(error)
            notify('danger', 'Não foi possível salvar script de venda')
            if (error.response) updateErros(error.response)
        }
    }

    function bind() {
        return {
            titulo,
            descricao,
            conteudo,
            tags,
            situacao: situacao || null,
            perfil_negocio_id: perfilNegocioId ? Number(perfilNegocioId) : null,
        }
    }

    async function handleDelete() {
        if (window.confirm("Deseja remover este script de venda?")) {
            try {
                await api.delete(`/common/empresas/${empresaSelecionada?.id}/scripts-venda/${scriptId}`)
                successAlert('Script de Venda removido')
            } catch (error) {
                console.error(error)
                notify('danger', 'Não foi possível remover script de venda')
            }
        }
    }

    const redirectBack = () => {
        history.goBack();
    };

    const successAlert = (msg: string) => {
        setAlert(
            <ReactBSAlert
                success
                style={{ display: "block", marginTop: "-100px", maxWidth: "500px" }}
                title={msg}
                onConfirm={redirectBack}
                confirmBtnBsStyle="success"
                showConfirm={false}
                btnSize=""
            />
        )
        setTimeout(redirectBack, 2000);
    };

    async function updateErros(response: AxiosResponse) {
        const responseErro = await response.data
        const bind = bindErrors(responseErro)
        if ((typeof bind) == 'string') {
            notify('danger', bind)
        } else if ((typeof bind) == 'object') {
            //@ts-ignore
            setErros(bind as IError)
        }
    }

    return (
        <>
            <div className="rna-wrapper">
                <NotificationAlert ref={notificationAlert} />
            </div>
            {alert}
            <div className="w-100">
                <Card>
                    <CardHeader>
                        <h1>
                            {script.id ? 'Alterar Script de Venda' : 'Novo Script de Venda'}
                        </h1>
                    </CardHeader>
                    <CardBody outline body>
                        <Row>
                            <Col lg="6" sm="12" md="12">
                                <FormGroup>
                                    <label className="form-control-label">
                                        Título*
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        placeholder="Título..."
                                        type="text"
                                        name="titulo"
                                        value={titulo}
                                        onChange={e => setTitulo(e.target.value)}
                                    />
                                    <small className="text-danger">
                                        {erros.titulo || ''}
                                    </small>
                                </FormGroup>
                            </Col>
                            <Col lg="6" sm="12" md="12">
                                <FormGroup>
                                    <label className="form-control-label">
                                        Tags
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        placeholder="Tags separadas por vírgula..."
                                        type="text"
                                        name="tags"
                                        value={tags}
                                        onChange={e => setTags(e.target.value)}
                                    />
                                    <small className="text-danger">
                                        {erros.tags || ''}
                                    </small>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="6" sm="12" md="12">
                                <FormGroup>
                                    <label className="form-control-label">
                                        Situação
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        name="situacao"
                                        value={situacao}
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option value="">Selecione...</option>
                                        {SITUACOES_SCRIPT.map((s) => (
                                            <option key={s.value} value={s.value}>{s.label}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col lg="6" sm="12" md="12">
                                <FormGroup>
                                    <label className="form-control-label">
                                        Perfil de Negócio
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        name="perfil_negocio_id"
                                        value={perfilNegocioId}
                                        onChange={e => setPerfilNegocioId(e.target.value)}
                                    >
                                        <option value="">Selecione...</option>
                                        {perfisNegocio.map((p) => (
                                            <option key={p.id} value={p.id}>{p.nome}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label className="form-control-label">
                                        Descrição
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        placeholder="Descrição..."
                                        type="textarea"
                                        name="descricao"
                                        value={descricao}
                                        onChange={e => setDescricao(e.target.value)}
                                        style={{ minHeight: 80 }}
                                    />
                                    <small className="text-danger">
                                        {erros.descricao || ''}
                                    </small>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label className="form-control-label">
                                        Conteúdo*
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        placeholder="Conteúdo do script..."
                                        type="textarea"
                                        name="conteudo"
                                        value={conteudo}
                                        onChange={e => setConteudo(e.target.value)}
                                        style={{ minHeight: 200 }}
                                    />
                                    <small className="text-danger">
                                        {erros.conteudo || ''}
                                    </small>
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter
                        style={{
                            position: "sticky",
                            bottom: 0,
                            border: "2 solid",
                            boxShadow: "0px 0px 2px 2px #f5f5f5",
                            zIndex: 9
                        }}
                    >
                        <Row>
                            <Col>
                                <div className="float-left">
                                    {script.id &&
                                        <Button
                                            color='danger'
                                            onClick={handleDelete}
                                        >
                                            Remover
                                        </Button>
                                    }
                                </div>
                            </Col>
                            <Col>
                                <div className="float-right">
                                    <Button
                                        className="ml-auto"
                                        color="link"
                                        data-dismiss="modal"
                                        type="button"
                                        disabled={saving}
                                        onClick={() => history.goBack()}
                                    >
                                        Voltar
                                    </Button>
                                    <Button
                                        color="primary"
                                        type="submit"
                                        disabled={saving}
                                        onClick={handleSave}>
                                        <Spinner
                                            hidden={!saving}
                                            className="mr-2"
                                            color="light"
                                            size="sm"
                                        />
                                        Salvar
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
            </div>
        </>
    )
}

export default Form;
